import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgHot(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5775_5623)">
        <path
          d="M3.5 10C3.5 10.6389 3.63542 11.2465 3.90625 11.8229C4.17708 12.3993 4.55556 12.9097 5.04167 13.3542C5.02778 13.2847 5.01736 13.2153 5.01042 13.1458C5.00347 13.0764 5 13.0069 5 12.9375C5 12.5625 5.06944 12.2118 5.20833 11.8854C5.34722 11.559 5.53472 11.2639 5.77083 11L8 8.5L10.2292 11C10.4653 11.2778 10.6528 11.5799 10.7917 11.9062C10.9306 12.2326 11 12.5764 11 12.9375C11 13.0069 10.9965 13.0799 10.9896 13.1562C10.9826 13.2326 10.9722 13.3056 10.9583 13.375C11.4444 12.9722 11.8229 12.4757 12.0938 11.8854C12.3646 11.2951 12.5 10.6667 12.5 10C12.5 9.29167 12.3785 8.59375 12.1354 7.90625C11.8924 7.21875 11.5417 6.58333 11.0833 6C10.8472 6.15278 10.6007 6.27083 10.3438 6.35417C10.0868 6.4375 9.80556 6.47917 9.5 6.47917C8.77778 6.47917 8.14236 6.25694 7.59375 5.8125C7.04514 5.36806 6.70139 4.79167 6.5625 4.08333C6.0625 4.54167 5.625 5.01042 5.25 5.48958C4.875 5.96875 4.55556 6.45833 4.29167 6.95833C4.02778 7.45833 3.82986 7.96528 3.69792 8.47917C3.56597 8.99306 3.5 9.5 3.5 10ZM8 10.75L6.89583 12C6.77083 12.1528 6.67361 12.309 6.60417 12.4688C6.53472 12.6285 6.5 12.8056 6.5 13C6.5 13.4167 6.64583 13.7708 6.9375 14.0625C7.22917 14.3542 7.58333 14.5 8 14.5C8.41667 14.5 8.77083 14.3542 9.0625 14.0625C9.35417 13.7708 9.5 13.4167 9.5 13C9.5 12.8056 9.46528 12.625 9.39583 12.4583C9.32639 12.2917 9.22917 12.1389 9.10417 12L8 10.75ZM8 1V3.47917C8 3.89583 8.14583 4.25 8.4375 4.54167C8.72917 4.83333 9.08333 4.97917 9.5 4.97917C9.73611 4.97917 9.95486 4.93056 10.1562 4.83333C10.3576 4.73611 10.5278 4.59722 10.6667 4.41667L11 4C11.8889 4.52778 12.6111 5.35069 13.1667 6.46875C13.7222 7.58681 14 8.76389 14 10C14 11.6667 13.4167 13.0833 12.25 14.25C11.0833 15.4167 9.66667 16 8 16C6.33333 16 4.91667 15.4167 3.75 14.25C2.58333 13.0833 2 11.6667 2 10C2 8.44444 2.52778 6.87153 3.58333 5.28125C4.63889 3.69097 6.11111 2.26389 8 1Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_5775_5623">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(0 -1 1 0 0 16)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
